import React from 'react';

import LoginForm from './LoginForm';

const Login = () => <LoginForm />;

export default Login;
